import React from 'react';
import { Icons } from '../icons.jsx';

// =============================================
// BOTTOM NAVIGATION COMPONENT
// =============================================

export function BottomNav({ 
    activeSection, 
    setActiveSection, 
    setActiveModule, 
    showMoreDrawer, 
    setShowMoreDrawer,
    personalLoans 
}) {
    // Check if any personal loans have pending payments this month
    const hasPendingLoans = personalLoans?.some(l => {
        const period = new Date().toISOString().slice(0, 7);
        return !(l.paymentHistory || []).some(p => p.period === period);
    });

    return (
        <nav className="bottom-nav">
            {/* Home */}
            <button
                className={`nav-btn ${activeSection === 'dashboard' ? 'active' : ''}`}
                style={{ '--nav-color': '#FFD700' }}
                onClick={() => { setActiveSection('dashboard'); setShowMoreDrawer(false); }}
            >
                <span className="nav-icon">{Icons.dashboard}</span>
                <span>Home</span>
            </button>

            {/* Wealth — Accounts + Gold (Invest & Property in More drawer) */}
            <button
                className={`nav-btn ${['assets', 'investments', 'fixed-assets'].includes(activeSection) ? 'active' : ''}`}
                style={{ '--nav-color': '#10B981' }}
                onClick={() => {
                    setShowMoreDrawer(false);
                    // If already in a wealth section, stay there; otherwise default to accounts
                    if (!['assets', 'investments', 'fixed-assets'].includes(activeSection)) {
                        setActiveSection('assets');
                        setActiveModule('accounts');
                    }
                }}
            >
                <span className="nav-icon">{Icons.accounts}</span>
                <span>Wealth</span>
            </button>

            {/* Debt — Loans + Pawning + Cards */}
            <button
                className={`nav-btn ${activeSection === 'liabilities' ? 'active' : ''}`}
                style={{ '--nav-color': '#EF4444' }}
                onClick={() => {
                    setShowMoreDrawer(false);
                    setActiveSection('liabilities');
                    setActiveModule('personal');
                }}
            >
                {/* Badge when loans have pending payments this month */}
                {hasPendingLoans && <span className="nav-badge" />}
                <span className="nav-icon">{Icons.loans}</span>
                <span>Debt</span>
            </button>

            {/* Budget */}
            <button
                className={`nav-btn ${activeSection === 'budget' ? 'active' : ''}`}
                style={{ '--nav-color': '#60A5FA' }}
                onClick={() => {
                    setShowMoreDrawer(false);
                    setActiveSection('budget');
                    setActiveModule('budget-dashboard');
                }}
            >
                <span className="nav-icon">{Icons.budget}</span>
                <span>Budget</span>
            </button>

            {/* More — opens drawer */}
            <button
                className={`nav-btn ${showMoreDrawer || ['settings', 'fi-advisor'].includes(activeSection) ? 'active' : ''}`}
                style={{ '--nav-color': '#A78BFA' }}
                onClick={() => setShowMoreDrawer(prev => !prev)}
            >
                <span className="nav-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="5" cy="12" r="1.5" fill="currentColor" stroke="none" />
                        <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
                        <circle cx="19" cy="12" r="1.5" fill="currentColor" stroke="none" />
                    </svg>
                </span>
                <span>More</span>
            </button>
        </nav>
    );
}
